import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core'
import listingColors from 'bpm/pages/ProductsPage/ProductDetailsPage/listingColors'

export const {
    historyHeaderDetailsText,
    buttonPrimary,
    buttonSecondary,
    defaultLight,
    propertiesDivider,
    productDetailsText,
    titleColor,
} = listingColors

const useStyles = makeStyles((theme: Theme) => ({
    dialogContainer: {
        width: '100vw',
    },
    dialogTitle: {
        color: historyHeaderDetailsText,
        padding: theme.spacing(3, 3, 0, 3),
        '& .MuiTypography-h6': {
            fontSize: pxToRem(33),
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    dialogContent: {
        padding: 0,
        paddingTop: theme.spacing(2),
    },
    dialogActions: {
        margin: theme.spacing(2.5),
    },
    productDetailsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        paddingBottom: theme.spacing(3),
        borderBottom: `1px solid ${propertiesDivider}`,
    },
    productDetails: {
        display: 'flex',
        alignItems: 'baseline',
        color: historyHeaderDetailsText,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(18),
        letterSpacing: '0.5px',
        marginLeft: theme.spacing(7),
    },
    productDetailsLabel: {
        lineHeight: 'inherit',
        fontSize: 'inherit',
        fontWeight: 700,
        letterSpacing: '0.5px',
        marginRight: '1rem',
    },
    productName: {
        color: buttonSecondary,
        fontSize: pxToRem(22),
        fontFamily: 'Roboto',
        fontWeight: 600,
        marginLeft: theme.spacing(5),
        marginBottom: theme.spacing(1),
    },
}))

export default useStyles
